export default __webpack_public_path__ + "static/media/sticker-x.c50c884f.png";